import type { ReactNode } from "react";
import { CodeMarkdown } from "@/components/storyboard/code/CodeMarkdown";
import QuizEntryCounter from "@/components/storyboard/quiz/QuizEntryCounter";

interface QuizReviewQuestionProps {
  prompt: string;
  index?: number;
  total?: number;
  counterLabel?: string;
  children: ReactNode;
}

/**
 * One completed quiz entry in the read-only review list — prompt, then the
 * learner's answers. `index` is 0-based; QuizEntryCounter turns it into
 * "Frage n/m" after the prompt, same as live quizzes.
 */
const QuizReviewQuestion = ({
  prompt,
  index = 0,
  total = 1,
  counterLabel = "Frage",
  children,
}: QuizReviewQuestionProps) => (
  <div
    data-slot="quiz-review-question"
    className="rounded-xl border border-gray-200 bg-white py-5 pl-3 pr-5"
  >
    <QuizEntryCounter currentIndex={index} total={total} label={counterLabel}>
      <div className="prose quiz-question min-w-0 max-w-full font-semibold text-primary">
        <CodeMarkdown>{prompt}</CodeMarkdown>
      </div>
    </QuizEntryCounter>

    <div className="mt-4">{children}</div>
  </div>
);

export default QuizReviewQuestion;
